import React from "react";
import {
  makeStyles,
  Container,
  Grid,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import AThirdBanner from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/AThirdBanner";
import TwoThirdNotice from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoThirdNotice";
import TwoSecondWebtoon from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoSecondWebtoon";
import ThreeThirdVideo from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/ThreeThirdVideo";
import TwoSecondCompetition from "../../../components/MainComponent/SecondSectionComponent/LhrsDividedComponent/TwoSecondCompetition";

const useStyles = makeStyles((theme) => ({
  totalContainer: {
    paddingTop: "6rem",
    paddingBottom: "6rem",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "4rem",
      paddingBottom: "4rem",
    },
    // paddingLeft: "4rem",
    // paddingRight: "4rem",
    // margin: " 0 -15px",
    // marginTop: " -20vh",
  },
}));

interface SecondSectionProps {
  match: any;
}

function SecondSection({ match }: SecondSectionProps) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Container
      maxWidth={"lg"}
      disableGutters
      style={
        {
          //  minHeight: "150vh"
        }
      }
    >
      <Grid xs={12} item container className={classes.totalContainer}>
        <TwoThirdNotice match={match} />
        {!matches ? <AThirdBanner /> : <div></div>}
        <ThreeThirdVideo />
        <TwoSecondCompetition />
        <TwoSecondWebtoon />
      </Grid>
    </Container>
  );
}

// export default MainContainer;
export default SecondSection;
